'use strict';

const h = require('phy');

const ApplyPromoCodeContainer = require('../../containers/desktop/apply_promo_code_container');
const SelecUserComponent = require('./select_user_component');

const renderComponent = props => {
  const { isSelectUser } = props;

  switch (true) {
    case isSelectUser: {
      return h(SelecUserComponent, props);
    }
    default: {
      return h(ApplyPromoCodeContainer, props);
    }
  }
};

const promoWrapperComponent = props => {
  if (!props.promoMessage || props.touchRequest) return null;
  return h('.promo-code-v2', renderComponent(props));
};

module.exports = promoWrapperComponent;
